<template>
  <header
    class="sticky inset-0 w-full h-16 md:h-20 z-40 px-5 md:px-8 flex justify-between items-center border-b border-border-color bg-white font-bold text-black-10 mt-7"
  >
    <div class="flex gap-3 md:gap-10 items-center">
      <app-logo />
      <div
        class="text-xl border-l border-primary font-light pl-8"
        test-id="title"
      >
        Manage Webhook
      </div>
    </div>

    <div>
      <span
        class="cursor-pointer mr-48 inline-block rounded-full bg-secondary p-2"
        @click="goBack"
      >
        <close-icon size="h-4 w-4" />
      </span>
    </div>
  </header>
</template>

<script>
export default {
  components: {
    CloseIcon: () => import('@/assets/v2/icons/CloseIcon.vue'),
    AppLogo: () => import('@/assets/images/AppLogo.vue')
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped></style>
